import type { IconSvgObject } from './types';

const SecurityWifiIcon: IconSvgObject = [
  ["path", { d: "M21 5C18.8786 3.17002 15.6351 2 12 2C8.36494 2 5.12137 3.17002 3 5V11C3 19 12 22 12 22C12 22 21 19 21 11L21 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 12.3647C10.2106 11.7981 11.0929 11.4904 12.0018 11.4922C12.9106 11.494 13.7917 11.8053 14.5 12.3747M12 15.5H12.01M7 9.255C8.4189 8.11897 10.1824 7.5 12 7.5C13.8176 7.5 15.5811 8.11897 17 9.255", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SecurityWifiIcon;
